var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEafc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.15961 3L3.76026 7.49153L6.37761 3H1.15961Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3329 11.143L12.2471 16.4414L11.7813 15.6373L17.4706 5.87512H18.405L15.8015 10.3417H19.0842L23.3401 3C23.3401 3 17.8976 3 17.0048 3C15.8486 3 15.1694 4.07575 15.1694 4.07575C15.1694 4.07575 9.11126 14.4784 9.10575 14.4784C8.79522 15.105 8.79522 16.1253 9.11126 16.713C9.11681 16.7241 12.2498 22.1278 12.2498 22.1278L18.6212 11.1374H15.3329V11.143Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.78758 9.54877H11.0435L12.7237 6.66254H8.46501L8.93355 5.85851H13.1923L14.8586 3C14.8586 3 9.68771 3 8.58144 3C7.3837 3 6.68224 4.0813 6.68224 4.0813L4.22574 8.29556L5.86711 11.1264L6.78758 9.54877Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEafc);
export default __webpack_public_path__ + "static/media/eafc.9f10b8e161ca732a5ebec9d2453924db.svg";
export { ForwardRef as ReactComponent };